export default __webpack_public_path__ + "static/14_29-7249ad90813c92904ffe7b8af7f26d05.png";